import $ from 'jquery';
import twitterFetcher from 'twitter-fetcher';

export default class DynamicTwitter {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    this.initializedClass = 'twitter-initialized';
    this.tweetContainer = $('[data-twitter-tweets]', this.el);

    this.showImages = section.data.show_images;
    this.showRetweets = section.data.show_retweets;
    this.username = section.data.username;

    const isInitialized = this.$el.hasClass(this.initializedClass);

    if (!isInitialized) {
      this._fetchTweets();
    }
  }

  _fetchTweets() {
    const config = {
      profile: { screenName: this.username },
      maxTweets: 1,
      enableLinks: true,
      showUser: true,
      showTime: true,
      showRetweet: this.showRetweets,
      customCallback: tweets => this.renderTweets(tweets),
      showInteraction: false,
      useEmoji: true,
      showImages: this.showImages,
    };

    twitterFetcher.fetch(config);
  }

  renderTweets(tweets) {
    if (tweets.length) {
      for (let i = 0; i < tweets.length; i++) {
        const $tweet = $(tweets[i]);

        this.tweetContainer.append(`
          <div class='tweet-wrap'>
            ${
              this.showImages && $tweet[3] ?
              `<div class="tweet-image">
                ${$tweet[3].innerHTML}
              </div>` :
              ' '
            }

            ${$tweet[1].innerHTML}

            <span class='timestamp'>
              ${$tweet[2].innerHTML}

              <span class='divider'>/</span>

              ${$tweet[0].innerHTML}
            </span>
          </div>
        `);
      }

      this.$el.toggleClass(this.initializedClass, true);
    } else {
      // twitterFetcher changes the view element to window, so we cannot use @$el here
      this.tweetContainer.html('');
      console.log('No tweets to display. Most probable cause is an incorrectly entered username.');
    }
  }
}
